import { useQuery } from "@tanstack/react-query";
import { FIVE_MINUTES_IN_MS } from "../configuration/globalConstants";
import { getMotionsDynamic } from "../services/viewingMotionsServices";
import { useState } from "react";

export function useMotionsDynamic() {
    const [params, setParams] = useState(null);

  const motions = useQuery({
    queryKey: ["motionsDynamic", params],
    queryFn: () => getMotionsDynamic(params),
    staleTime: FIVE_MINUTES_IN_MS,
    enabled: !!params,
  });

  return {
    filteredMotions: motions.data || [],
    isLoadingFilteredMotions: motions.isLoading,
    getFilteredMotions: (newParams) => {
      setParams(newParams);
    },
    filteredParams: params,
  };
}
